// app/javascript/controllers/attention_controller.js
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    const dataset = this.element.dataset
    this.urlValue = dataset.attentionUrlValue
    this.updateAllStyles()
  }

  toggle(event) {
    this.updateStyles(event.currentTarget)
    this.sendUpdate()
  }

  updateAllStyles() {
    this.inputTargets.forEach((el) => this.updateStyles(el))
  }

  updateStyles(checkbox) {
    const switchEl = checkbox.nextElementSibling
    console.log(checkbox)
    console.log(checkbox.checked)
    switchEl.classList.toggle("bg-blue-500", checkbox.checked)
    switchEl.classList.toggle("bg-gray-300", !checkbox.checked)
    const knob = switchEl.querySelector("span")
    knob.classList.toggle("translate-x-4", checkbox.checked)
    knob.classList.toggle("translate-x-0", !checkbox.checked)
  }

  sendUpdate() {
    const selected = this.inputTargets
      .filter((el) => el.checked)
      .map((el) => el.value)
    console.log('url', this.urlValue)
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
        "Accept": "application/json"
      },
      body: JSON.stringify({ institution: { attention_types: selected } })
    }).then((response) => {
      if (!response.ok) {
        console.error("Error actualizando tipos de atención")
      }
    })
  }
}
